import { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const Card = ({ children, className, ...rest }: CardProps) => (
  <div
    className={[
      'rounded-lg border border-slate-200 bg-white p-5 shadow-sm sm:p-6',
      className ?? '',
    ].join(' ')}
    {...rest}
  >
    {children}
  </div>
);

export default Card;
